import request from "@/lib/axios";
export function getLogin(query) {
  return request({
    method: "POST",
    url: "/login",
    data: query
  });
}

export function getAssembly(query) {
  return request({
    method: "GET",
    url: "/assembly",
    params: query
  });
}
export function getVtm(query) {
  return request({
    method: "GET",
    url: "/vtm",
    params: query
  });
}

export function getAllShortVinBrand(query) {
  return request({
    method: "GET",
    url: "/getAllShortVinBrand",
    params: query
  });
}

export function getParts(query) {
  return request({
    method: "GET",
    url: "/parts",
    params: query
  });
}

export function getCarTypeInfo(query) {
  return request({
    method: "GET",
    url: "/carTypeInfo",
    params: query
  });
}

export function getCarType(query) {
  return request({
    method: "GET",
    url: "/carType",
    params: query
  });
}

export function getBenBenUseStat(query) {
  return request({
    method: "GET",
    url: "/getBenBenUseStat",
    params: query
  });
}

export function getPartsBySearchKey(query) {
  return request({
    method: "GET",
    url: "/getPartsBySearchKey",
    params: query
  });
}
//获取供应商零件信息
export function getSupplierPartInfo(query) {
  return request({
    method: "POST",
    url: "/getSupplierPartInfo",
    data: query
  });
}
// 加入购物车
export function addCartBatch(query) {
  return request({
    method: "POST",
    url: "/addCartBatch",
    data: query
  });
}
// 下单
export function saveOrderRecord(query) {
  return request({
    method: "POST",
    url: "/saveOrderRecord",
    data: query
  });
}
